// Product 18 from the uploaded Hi Tours Products Itinerary (Egypt Explorer — Grand Luxury Edition).
// Entire detail page content in English.

export const detail = {
  slug: 'egypt-pyramids-nile-cruise-and-red-sea',
  ctaHref: '/l/egypt/enquiry/passengers/',
  cta: 'Design Your Escape',
  sub: 'Your travel plan – non-binding & tailor-made',
  banner: 'Worry-free planning: stable flight prices for over a year, plus flexible rebooking and cancellation options.',
  title: 'Egypt Explorer: Pyramids, Nile & Red Sea Beach Retreat — Grand Luxury Edition',
  alt: 'Egypt Explorer: Pyramids, Nile & Red Sea Beach Retreat — Grand Luxury Edition',
  days: '11 days',
  stations: '5 stops',
  transport: 'Private transfer',
  tag: 'Culture',
  price: 144000,
  routeCode: 'EG-CAI-ASW-LXR-HRG-CAI · 11D',
  routeLabel: 'This holiday takes you to',
  routeCodeLabel: 'Route code',
  routeCities: ['Cairo', 'Aswan', 'Edfu', 'Luxor', 'Hurghada', 'Cairo'],
  tags: ['Culture', 'Honeymoon', 'Luxury'],
  stats: { days: 11, cities: 5, hotels: 4, activities: 12, transfers: 9 },
  gallery: [
    'https://kiwi-cdn.tlservers.com/items%2F9dbcb14f-a83e-414f-8ed1-2f7f9b1173d7%2Fimage%2Fjpeg%2FPbCTUPKH54s1ML3VuZworA%2FiStock-1691038856.jpg?w=1080&q=75&auto=format&fit=max',
    'https://kiwi-cdn.tlservers.com/items%2Fb8fb6a95-8fb3-4ef5-aa8e-fdbf751ddb01%2Fimage%2Fjpeg%2F9kORDM_-0K_Ej3bFpKTQYA%2Fpradeep-gopal-6ujdeqx-cho-unsplash.jpg?w=640&q=75&auto=format&fit=max',
    'https://kiwi-cdn.tlservers.com/items%2F7b743050-b17f-42b2-8179-d1e6fae370e8%2Fimage%2Fjpeg%2FjI5MNhhx8eaOMbuhVEEtJg%2FiStock-1305840978.jpg?w=640&q=75&auto=format&fit=max',
    'https://kiwi-cdn.tlservers.com/items%2F608dcfcc-6d40-4685-ae74-28b202065d17%2Fimage%2Fjpeg%2Fy9wSLsrUJaNZMRijYSTA4g%2FiStock-1208082130.jpg?w=640&q=75&auto=format&fit=max',
    'https://kiwi-cdn.tlservers.com/items%2F7b743050-b17f-42b2-8179-d1e6fae370e8%2Fimage%2Fjpeg%2FgGF9ayHbRxAtvOQoxtnHjg%2FiStock-1355995823.jpg?w=640&q=75&auto=format&fit=max'
  ],
  services: [['4 hotels', 'Accommodation'], ['12 activities', 'Activities'], ['9 transfers', 'Transport'], ['25 meals', 'Meals'], ['24/7 support', '24/7 Support'], ['Customisation', 'Customise', 'Expert customisation']],
  expert: {
    name: 'Ria Banerjee',
    image: '/egypt/expert-ria.webp',
    role: 'Egypt expert at Hi Tours',
    createdBy: 'Trip created by',
    quote: 'Pyramids, a relaxed Nile cruise and a Red Sea beach finale, all in one journey.',
    quoteMore: 'My tip: see the Valley of the Kings early, while the tombs are cool and quiet. I especially recommend the Temple of Edfu, reached by horse carriage and one of the best-preserved temples in all of Egypt, and the Grand Egyptian Museum with the complete Tutankhamun collection.',
    more: 'Read more',
    less: 'Read less'
  }
};

export const route = {
  h2: 'Your suggested itinerary',
  sub: 'Fully customisable with our holiday experts',
  summaryCta: 'View tour summary',
  summaryShort: 'Tour summary',
  accommodationHeading: 'Your accommodation',
  viewPhotos: 'View photos',
  programHeading: 'Your activities',
  optional: 'Optional',
  more: 'Show more',
  less: 'Show less',
  stops: [
    {
      letter: 'A',
      name: 'Cairo',
      dayLabel: 'Day 1–4',
      bullets: [
        'Meet & assist at Cairo airport, private transfer to your hotel',
        'Pyramids of Giza & the Sphinx with your Egyptologist guide',
        'Grand Egyptian Museum incl. the Tutankhamun collection',
        'Old Cairo, the Citadel & Khan el-Khalili bazaar (optional)',
        'Day 4: flight Cairo → Aswan and transfer to your ship'
      ],
      images: [
        'https://kiwi-cdn.tlservers.com/items%2Fb8fb6a95-8fb3-4ef5-aa8e-fdbf751ddb01%2Fimage%2Fjpeg%2F9kORDM_-0K_Ej3bFpKTQYA%2Fpradeep-gopal-6ujdeqx-cho-unsplash.jpg?w=640&q=75&auto=format&fit=max',
        'https://kiwi-cdn.tlservers.com/items%2Fb8fb6a95-8fb3-4ef5-aa8e-fdbf751ddb01%2Fimage%2Fjpeg%2FhWyz3DR4zUzH04PXYmTU1g%2Fistock-1992596991.jpg?w=640&q=75&auto=format&fit=max',
        'https://kiwi-cdn.tlservers.com/items%2Fb8fb6a95-8fb3-4ef5-aa8e-fdbf751ddb01%2Fimage%2Fjpeg%2Fz4w2_1pVJSBuOiCrr8Mrkw%2Fricardo-gomez-angel-haw4e-f4kly-unsplash.jpg?w=640&q=75&auto=format&fit=max',
        'https://kiwi-cdn.tlservers.com/items%2Fb8fb6a95-8fb3-4ef5-aa8e-fdbf751ddb01%2Fimage%2Fjpeg%2F1MR1-wDsVUGDJiIKRYwF_w%2Fistock-2152790069.jpg?w=640&q=75&auto=format&fit=max'
      ],
      activities: [
        { name: 'Pyramids of Giza & the Sphinx', description: 'Half-day guided tour of the three pyramids and the Sphinx.', optional: false, image: 'https://kiwi-cdn.tlservers.com/activities%2Fbfb9504e-6013-4e1f-8222-eea32df5429f%2Fimage%2Fjpeg%2FyU9CWklfqHs_iUwXLmiygw%2FiStock-2239876304.jpg?w=640&q=75&auto=format&fit=max' },
        { name: 'Grand Egyptian Museum', description: 'Guided visit incl. the Tutankhamun collection.', optional: false, image: 'https://kiwi-cdn.tlservers.com/items%2Fb8fb6a95-8fb3-4ef5-aa8e-fdbf751ddb01%2Fimage%2Fjpeg%2FhWyz3DR4zUzH04PXYmTU1g%2Fistock-1992596991.jpg?w=640&q=75&auto=format&fit=max' },
        { name: 'Old Cairo & Khan el-Khalili', description: 'Coptic Cairo, the Citadel and the historic bazaar.', optional: true, image: 'https://kiwi-cdn.tlservers.com/items%2Fb8fb6a95-8fb3-4ef5-aa8e-fdbf751ddb01%2Fimage%2Fjpeg%2Fz4w2_1pVJSBuOiCrr8Mrkw%2Fricardo-gomez-angel-haw4e-f4kly-unsplash.jpg?w=640&q=75&auto=format&fit=max' }
      ],

      accommodation: {
        name: 'Semiramis InterContinental Cairo',
        description: '4 nights · half board · Nile city-view room',
        images: [
          'https://catalog-cdn-production.tlservers.com/images/content_accommodations/3383/a896f1af52b6d5446d9969f0762f735765e60b916794fa037d620c9456c439f5.jpg?w=640&q=75&auto=format&fit=max',
          'https://catalog-cdn-production.tlservers.com/images/content_accommodations/3383/f48a09c5b54f4fa9cbda40bc6686bffc4df51096a18e4003cb12e9335c37a8e7.jpg?w=640&q=75&auto=format&fit=max',
          'https://catalog-cdn-production.tlservers.com/images/content_accommodations/3383/3a98afa8b18eb5aab4acb411e2d4c9358c82360933f9214d7e58c42d4cbcc7f0.jpg?w=640&q=75&auto=format&fit=max'
        ]
      },
      program: {
        name: 'Pyramids of Giza & Grand Egyptian Museum',
        description: 'A half-day tour of the Pyramids of Giza and the Sphinx, plus a half-day visit to the Grand Egyptian Museum with its complete Tutankhamun collection. History comes to life!',
        image: 'https://kiwi-cdn.tlservers.com/activities%2Fbfb9504e-6013-4e1f-8222-eea32df5429f%2Fimage%2Fjpeg%2FyU9CWklfqHs_iUwXLmiygw%2FiStock-2239876304.jpg?w=640&q=75&auto=format&fit=max'
      },
      programDetail: {
        h3: 'Full-day visit to the Grand Egyptian Museum',
        points: [
          { h: '1. Exquisite collections of ancient artefacts', t: 'The Grand Egyptian Museum houses one of the largest and most significant collections of ancient Egyptian antiquities in the world. You will find everything from monumental statues and intricate jewellery to everyday objects used by the ancient Egyptians. The galleries are organised by theme and trace the evolution of Egyptian art, religion and society across millennia.' },
          { h: '2. The treasures of King Tutankhamun', t: 'A highlight is the collection dedicated to the treasures of King Tutankhamun. The museum displays the most complete set of objects from his tomb, including his famous golden mask, chariots, jewellery and the astonishing variety of items buried with him in 1922 — a unique chance to see these treasures in a state-of-the-art setting.' },
          { h: '3. Royal Mummies Hall', t: 'The museum also presents an incredible display of royal mummies, including those of pharaohs such as Ramses II and Seti I. This exhibition offers fascinating insight into ancient Egyptian burial practices, body preservation and the mummification process.' },
          { h: '4. Modern architecture and design', t: 'The Grand Egyptian Museum is itself a masterpiece of modern architecture, with a striking design that blends seamlessly into the desert landscape. Its expansive open spaces and innovative display techniques provide a breathtaking backdrop for the ancient artefacts and make for a truly immersive experience.' },
          { h: '5. Interactive and multimedia exhibits', t: 'The museum uses the latest technology to bring ancient Egypt to life. Interactive exhibits, digital reconstructions and multimedia presentations let you gain a deeper understanding of the historical context behind each artefact.' }
        ]
      }
    },
    {
      letter: 'B',
      name: 'Nile Cruise',
      subtitle: 'Aswan → Edfu → Luxor',
      dayLabel: 'Day 4–7',
      bullets: [
        'Board the M/S Concerto Plus in Aswan',
        'Philae Temple & the High Dam',
        'Sail to Kom Ombo – visit the twin temple of Sobek & Horus',
        'Edfu – Temple of Horus by horse carriage',
        'Sunset felucca sail (optional), arrive in Luxor on day 7'
      ],
      images: [
        'https://kiwi-cdn.tlservers.com/items%2Faac487ef-1314-4d93-809a-3f407a9b12b2%2Fimage%2Fjpeg%2FRudhVVpyaS21MwTtLaDafQ%2Fistock-185209709.jpg?w=640&q=75&auto=format&fit=max',
        'https://kiwi-cdn.tlservers.com/items%2Faac487ef-1314-4d93-809a-3f407a9b12b2%2Fimage%2Fjpeg%2FohpwYLxxL2KcB-CAsMAz7Q%2Fjordi-orts-segales-crq94fdpdw-unsplash.jpg?w=640&q=75&auto=format&fit=max',
        'https://kiwi-cdn.tlservers.com/items%2Faac487ef-1314-4d93-809a-3f407a9b12b2%2Fimage%2Fjpeg%2Fbq_A8ZGwybnect0xUvJJSQ%2Fistock-2181311638.jpg?w=640&q=75&auto=format&fit=max',
        'https://kiwi-cdn.tlservers.com/items%2F4f1d4380-39d1-4c0d-8e74-4bcae12bc068%2Fimage%2Fjpeg%2FNhB6Y-CMd191icD3i0KMQA%2Fmartijn-vonk-jaqkmulkw2m-unsplash.jpg?w=640&q=75&auto=format&fit=max'
      ],
      activities: [
        { name: 'Kom Ombo Temple', description: 'The twin temple of Sobek and Horus, right by the ship.', optional: false, image: 'https://kiwi-cdn.tlservers.com/activities%2Faca44a59-64e8-4c93-881a-140714e67535%2Fimage%2Fjpeg%2FyveIgYQwhqu-v7Eje5MSLA%2FIberotel+Empress+3.jpg?w=640&q=75&auto=format&fit=max' },
        { name: 'Temple of Horus at Edfu', description: 'Best-preserved temple in Egypt, by horse carriage.', optional: false, image: 'https://kiwi-cdn.tlservers.com/items%2Faac487ef-1314-4d93-809a-3f407a9b12b2%2Fimage%2Fjpeg%2FohpwYLxxL2KcB-CAsMAz7Q%2Fjordi-orts-segales-crq94fdpdw-unsplash.jpg?w=640&q=75&auto=format&fit=max' },
        { name: 'Philae Temple & High Dam', description: 'Aswan’s island temple of Isis and the High Dam.', optional: false, image: 'https://kiwi-cdn.tlservers.com/items%2Faac487ef-1314-4d93-809a-3f407a9b12b2%2Fimage%2Fjpeg%2Fbq_A8ZGwybnect0xUvJJSQ%2Fistock-2181311638.jpg?w=640&q=75&auto=format&fit=max' },
        { name: 'Felucca sail at sunset', description: 'Traditional sailing boat ride around Elephantine Island.', optional: true, image: 'https://kiwi-cdn.tlservers.com/items%2F4f1d4380-39d1-4c0d-8e74-4bcae12bc068%2Fimage%2Fjpeg%2FNhB6Y-CMd191icD3i0KMQA%2Fmartijn-vonk-jaqkmulkw2m-unsplash.jpg?w=640&q=75&auto=format&fit=max' }
      ],

      accommodation: {
        name: 'M/S Concerto Plus – Nile cruise ship',
        description: '3 nights · full board · deluxe cabin with panoramic window',
        images: [
          'https://kiwi-cdn.tlservers.com/items%2Fc81680aa-4f26-42eb-8dcd-426bdf9da122%2Fimage%2Fjpeg%2FYuP38L3SdxQsjK3gydd7Jg%2F1755599865544aswanxxxxxxxxxxxxi13021416by9.jpg?w=640&q=75&auto=format&fit=max',
          'https://kiwi-cdn.tlservers.com/items%2Fc81680aa-4f26-42eb-8dcd-426bdf9da122%2Fimage%2Fjpeg%2FNYBNt1qsL0H17iANQhBDSA%2F1755599865539aswanxxxxxxxxxxxxi1207013by2.jpg?w=640&q=75&auto=format&fit=max',
          'https://kiwi-cdn.tlservers.com/items%2Fc81680aa-4f26-42eb-8dcd-426bdf9da122%2Fimage%2Fjpeg%2FR6l8HHDI1m9dkGkoiH_C_Q%2F1755599865542aswanxxxxxxxxxxxxi12070713by5.jpg?w=640&q=75&auto=format&fit=max'
        ]
      },
      program: {
        name: 'Kom Ombo & Edfu Temples',
        description: 'Visit the dual-deity Kom Ombo Temple of Sobek and Horus, then the beautifully preserved Temple of Horus at Edfu, reached by a traditional horse carriage.',
        image: 'https://kiwi-cdn.tlservers.com/activities%2Faca44a59-64e8-4c93-881a-140714e67535%2Fimage%2Fjpeg%2FyveIgYQwhqu-v7Eje5MSLA%2FIberotel+Empress+3.jpg?w=640&q=75&auto=format&fit=max'
      }
    },
    {
      letter: 'C',
      name: 'Luxor',
      subtitle: 'Luxor → Hurghada',
      dayLabel: 'Day 7',
      bullets: [
        'Valley of the Kings – three royal tombs',
        'Temple of Hatshepsut & Colossi of Memnon',
        'Karnak & Luxor temples on the East Bank',
        'Private transfer Luxor → Hurghada (approx. 4 h)'
      ],
      images: [
        'https://kiwi-cdn.tlservers.com/items%2F7b743050-b17f-42b2-8179-d1e6fae370e8%2Fimage%2Fjpeg%2FEIB8KA0OkA3jO_kZVHnoxA%2FiStock-1390987140.jpg?w=640&q=75&auto=format&fit=max',
        'https://kiwi-cdn.tlservers.com/items%2F7b743050-b17f-42b2-8179-d1e6fae370e8%2Fimage%2Fjpeg%2FPIdc0MCDsBQBv4hzKfXk4g%2FiStock-1124348420.jpg?w=640&q=75&auto=format&fit=max',
        'https://kiwi-cdn.tlservers.com/items%2F7b743050-b17f-42b2-8179-d1e6fae370e8%2Fimage%2Fjpeg%2FpVc-e95iu6acXBaeiBUo5Q%2FiStock-1342806543.jpg?w=640&q=75&auto=format&fit=max',
        'https://kiwi-cdn.tlservers.com/items%2F7b743050-b17f-42b2-8179-d1e6fae370e8%2Fimage%2Fjpeg%2F0HsK62Nf0vEfZXkmJalNdw%2FiStock-2151748276.jpg?w=640&q=75&auto=format&fit=max'
      ],
      activities: [
        { name: 'Valley of the Kings', description: 'Descend into three royal tombs on the West Bank.', optional: false, image: 'https://kiwi-cdn.tlservers.com/items%2F7b743050-b17f-42b2-8179-d1e6fae370e8%2Fimage%2Fjpeg%2Fk5u9iGiUwG7AlAR-dk53cA%2FiStock-511207904.jpg?w=640&q=75&auto=format&fit=max' },
        { name: 'Karnak Temple', description: 'The vast temple complex and its Great Hypostyle Hall.', optional: false, image: 'https://kiwi-cdn.tlservers.com/items%2F7b743050-b17f-42b2-8179-d1e6fae370e8%2Fimage%2Fjpeg%2FPIdc0MCDsBQBv4hzKfXk4g%2FiStock-1124348420.jpg?w=640&q=75&auto=format&fit=max' },
        { name: 'Temple of Hatshepsut', description: 'The terraced mortuary temple at Deir el-Bahari.', optional: true, image: 'https://kiwi-cdn.tlservers.com/items%2F7b743050-b17f-42b2-8179-d1e6fae370e8%2Fimage%2Fjpeg%2FpVc-e95iu6acXBaeiBUo5Q%2FiStock-1342806543.jpg?w=640&q=75&auto=format&fit=max' }
      ],

      accommodation: {
        name: 'Hurghada Marriott Beach Resort',
        description: '3 nights · all inclusive · sea-view room',
        images: [
          'https://kiwi-cdn.tlservers.com/items%2F11dab33a-edc9-4a57-9592-4764daaa57be%2Fimage%2Fjpeg%2FxqGWBLuhSklGbQiseymcIg%2F1742896601489_Overview-20185216.jpg?w=640&q=75&auto=format&fit=max',
          'https://kiwi-cdn.tlservers.com/items%2F11dab33a-edc9-4a57-9592-4764daaa57be%2Fimage%2Fjpeg%2FiF0wezWLjX_H8D2PFsVc4g%2F1742896601487_Lobby.jpg?w=640&q=75&auto=format&fit=max',
          'https://kiwi-cdn.tlservers.com/items%2F11dab33a-edc9-4a57-9592-4764daaa57be%2Fimage%2Fjpeg%2FYV5oZFtls8PL0Y_oXP8h7A%2F1742896601481_Al-Zaytoun-Main-Restaurant-20185216.jpg?w=640&q=75&auto=format&fit=max'
        ]
      },
      program: {
        name: 'Valley of the Kings & Karnak Temple',
        description: 'Guided visits to the Valley of the Kings, the Temple of Hatshepsut, the Colossi of Memnon and the great temples of Karnak and Luxor before transferring to the Red Sea.',
        image: 'https://kiwi-cdn.tlservers.com/items%2F7b743050-b17f-42b2-8179-d1e6fae370e8%2Fimage%2Fjpeg%2Fk5u9iGiUwG7AlAR-dk53cA%2FiStock-511207904.jpg?w=640&q=75&auto=format&fit=max'
      }
    },
    {
      letter: 'D',
      name: 'Hurghada',
      subtitle: 'Red Sea',
      dayLabel: 'Day 7–10',
      bullets: [
        'Check-in at your all-inclusive Red Sea resort',
        'Free days for beach, pool & water sports',
        'Snorkelling trip to Giftun Island (optional)',
        'Desert quad safari with Bedouin dinner (optional)',
        'Day 10: flight Hurghada → Cairo'
      ],
      images: [
        'https://kiwi-cdn.tlservers.com/items%2F608dcfcc-6d40-4685-ae74-28b202065d17%2Fimage%2Fjpeg%2Fy9wSLsrUJaNZMRijYSTA4g%2FiStock-1208082130.jpg?w=640&q=75&auto=format&fit=max',
        'https://kiwi-cdn.tlservers.com/items%2F608dcfcc-6d40-4685-ae74-28b202065d17%2Fimage%2Fjpeg%2FHg2vOD1So7jldYvue1bl1Q%2FiStock-1202686561+%281%29.jpg?w=640&q=75&auto=format&fit=max',
        'https://kiwi-cdn.tlservers.com/items%2F608dcfcc-6d40-4685-ae74-28b202065d17%2Fimage%2Fjpeg%2FOQJ4-2okN8wrB-gP1djj7w%2FiStock-467862934.jpg?w=640&q=75&auto=format&fit=max',
        'https://kiwi-cdn.tlservers.com/items%2F608dcfcc-6d40-4685-ae74-28b202065d17%2Fimage%2Fjpeg%2FEVvpjo1weiKBTfhFN_vgAw%2FiStock-1162326736.jpg?w=640&q=75&auto=format&fit=max'
      ],
      activities: [
        { name: 'Red Sea snorkelling trip', description: 'Boat trip to the Giftun Island reefs with lunch.', optional: true, image: 'https://kiwi-cdn.tlservers.com/items%2F608dcfcc-6d40-4685-ae74-28b202065d17%2Fimage%2Fjpeg%2Fy9wSLsrUJaNZMRijYSTA4g%2FiStock-1208082130.jpg?w=640&q=75&auto=format&fit=max' },
        { name: 'Desert quad safari', description: 'Late-afternoon quad ride with a Bedouin dinner.', optional: true, image: 'https://kiwi-cdn.tlservers.com/items%2F608dcfcc-6d40-4685-ae74-28b202065d17%2Fimage%2Fjpeg%2FHg2vOD1So7jldYvue1bl1Q%2FiStock-1202686561+%281%29.jpg?w=640&q=75&auto=format&fit=max' },
        { name: 'Beach & all-inclusive relaxation', description: 'Pool, beach and water sports at your resort.', optional: false, image: 'https://kiwi-cdn.tlservers.com/items%2F608dcfcc-6d40-4685-ae74-28b202065d17%2Fimage%2Fjpeg%2FOQJ4-2okN8wrB-gP1djj7w%2FiStock-467862934.jpg?w=640&q=75&auto=format&fit=max' }
      ],

      accommodation: {
        name: 'Hurghada Marriott Beach Resort',
        description: '3 nights · all inclusive · sea-view room',
        images: [
          'https://kiwi-cdn.tlservers.com/items%2F11dab33a-edc9-4a57-9592-4764daaa57be%2Fimage%2Fjpeg%2FxqGWBLuhSklGbQiseymcIg%2F1742896601489_Overview-20185216.jpg?w=640&q=75&auto=format&fit=max',
          'https://kiwi-cdn.tlservers.com/items%2F11dab33a-edc9-4a57-9592-4764daaa57be%2Fimage%2Fjpeg%2FiF0wezWLjX_H8D2PFsVc4g%2F1742896601487_Lobby.jpg?w=640&q=75&auto=format&fit=max',
          'https://kiwi-cdn.tlservers.com/items%2F11dab33a-edc9-4a57-9592-4764daaa57be%2Fimage%2Fjpeg%2FYV5oZFtls8PL0Y_oXP8h7A%2F1742896601481_Al-Zaytoun-Main-Restaurant-20185216.jpg?w=640&q=75&auto=format&fit=max'
        ]
      },
      program: null
    },
    {
      letter: 'E',
      name: 'Cairo',
      dayLabel: 'Day 10–11',
      bullets: [
        'Transfer to your hotel for a final night in Cairo',
        'Free evening or farewell Nile dinner cruise (optional)',
        'Private transfer to Cairo International Airport'
      ],
      images: [
        'https://kiwi-cdn.tlservers.com/items%2F9dbcb14f-a83e-414f-8ed1-2f7f9b1173d7%2Fimage%2Fjpeg%2FPbCTUPKH54s1ML3VuZworA%2FiStock-1691038856.jpg?w=640&q=75&auto=format&fit=max',
        'https://kiwi-cdn.tlservers.com/items%2Fb8fb6a95-8fb3-4ef5-aa8e-fdbf751ddb01%2Fimage%2Fjpeg%2FhWyz3DR4zUzH04PXYmTU1g%2Fistock-1992596991.jpg?w=640&q=75&auto=format&fit=max',
        'https://kiwi-cdn.tlservers.com/items%2Fb8fb6a95-8fb3-4ef5-aa8e-fdbf751ddb01%2Fimage%2Fjpeg%2Fz4w2_1pVJSBuOiCrr8Mrkw%2Fricardo-gomez-angel-haw4e-f4kly-unsplash.jpg?w=640&q=75&auto=format&fit=max'
      ],
      activities: [
        { name: 'Farewell Nile dinner cruise', description: 'Dinner on the Nile with live music on your last night.', optional: true, image: 'https://kiwi-cdn.tlservers.com/items%2F9dbcb14f-a83e-414f-8ed1-2f7f9b1173d7%2Fimage%2Fjpeg%2FPbCTUPKH54s1ML3VuZworA%2FiStock-1691038856.jpg?w=640&q=75&auto=format&fit=max' },
        { name: 'Departure transfer', description: 'Private transfer to Cairo International Airport.', optional: false, image: 'https://kiwi-cdn.tlservers.com/items%2Fb8fb6a95-8fb3-4ef5-aa8e-fdbf751ddb01%2Fimage%2Fjpeg%2FhWyz3DR4zUzH04PXYmTU1g%2Fistock-1992596991.jpg?w=640&q=75&auto=format&fit=max' }
      ],

      accommodation: {
        name: 'Semiramis InterContinental Cairo',
        description: '1 night · bed & breakfast · city-view room',
        images: [
          'https://catalog-cdn-production.tlservers.com/images/content_accommodations/3383/a896f1af52b6d5446d9969f0762f735765e60b916794fa037d620c9456c439f5.jpg?w=640&q=75&auto=format&fit=max',
          'https://catalog-cdn-production.tlservers.com/images/content_accommodations/3383/f48a09c5b54f4fa9cbda40bc6686bffc4df51096a18e4003cb12e9335c37a8e7.jpg?w=640&q=75&auto=format&fit=max'
        ]
      },
      program: null
    }
  ]
};

export const experts = {
  h2: 'Why plan with our experts?',
  count: '',
  avatars: [
    '/team/asia-1.webp',
    '/team/asia-2.webp',
    '/team/asia-3.webp',
    '/team/asia-4.webp',
    '/team/asia-5.webp'
  ],
  stats: [
    { h: 'Crafted by holiday experts', t: 'Technology-enabled but human-led — real experts curate your trip so you save hours of planning.' },
    { h: 'Customised to the T', t: 'Every day is tailored to you, then fine-tuned with your expert until it feels just right.' },
    { h: 'Best prices, all bundled', t: 'Hotels, flights, activities, transfers, entry tickets and meals in one package — with the savings passed to you.' }
  ]
};

export const glance = {
  h2: 'Tour summary',
  short: 'Pyramids and the Grand Egyptian Museum in Cairo, a relaxed Nile cruise from Aswan to Luxor and a Red Sea beach finale – 11 days, 5 cities.',
  readMore: 'Read more',
  readLess: 'Read less',
  hide: 'Hide tour summary',
  intro: 'Egypt Explorer combines the great highlights of Egypt in one journey: the Pyramids of Giza and the Grand Egyptian Museum in Cairo, a relaxed Nile cruise between Aswan, Kom Ombo, Edfu and Luxor, and a finishing beach stay on the Red Sea in Hurghada.',
  intro2: 'Along the Nile you discover the most important sites of Upper Egypt at a gentle pace, before swapping ancient temples for the beaches and coral reefs of the Red Sea — the perfect contrast to the cultural first half of the trip.',
  accommodationHeading: 'Accommodation',
  highlightsHeading: 'Key highlights',
  dayHeading: 'Day',
  routeHeading: 'Route',
  days: [
    { title: 'Day 1–4: Cairo (4 nights)', text: 'Your journey begins in Cairo with the world-famous pyramids, the Grand Egyptian Museum and a flight to Aswan to begin the Nile cruise.', hotel: 'Semiramis InterContinental Cairo', highlights: ['Airport meet & assist, private transfer to hotel', 'Pyramids of Giza & Sphinx', 'Grand Egyptian Museum', 'Flight Cairo → Aswan'] },
    { title: 'Day 4–7: Nile Cruise Aswan → Edfu → Luxor (3 nights)', text: 'Relaxed cruising on the Nile with visits to the temples of Kom Ombo and Edfu.', hotel: 'M/S Concerto Plus (Nile cruise)', highlights: ['Transfer Aswan airport → ship', 'Philae Temple & High Dam', 'Kom Ombo Temple', 'Edfu Temple by horse carriage'] },
    { title: 'Day 7: Luxor → Hurghada', text: 'Luxor\u2019s West and East Banks in the morning, followed by a transfer to the Red Sea.', hotel: 'Hurghada Marriott Beach Resort', highlights: ['Valley of the Kings', 'Karnak & Luxor Temples', 'Private transfer Luxor → Hurghada'] },
    { title: 'Day 7–10: Hurghada – Red Sea (3 nights)', text: 'Relax on the Red Sea on an all-inclusive basis, with time for the beach and water sports.', hotel: 'Hurghada Marriott Beach Resort', highlights: ['Red Sea beach stay (all inclusive)', 'Snorkelling & diving (optional)', 'Flight Hurghada → Cairo'] },
    { title: 'Day 10–11: Cairo', text: 'Fly back to Cairo for a final overnight before your departure.', hotel: 'Semiramis InterContinental Cairo', highlights: ['Airport → hotel transfer', 'Farewell Nile dinner cruise (optional)', 'Private transfer to Cairo airport'] }
  ],
  outro: 'On the final day your Egypt journey ends with a departure transfer from Cairo — a balanced combination of culture, Nile cruising and Red Sea beach time.'
};

export const brandFeatures = {
  h2: 'Why book with Hi Tours',
  items: [
    { icon: '/pros/experts.png', title: 'Real travel experts', text: 'Benefit from our local expertise and award-winning service.' },
    { icon: '/pros/organised.png', title: 'Fully organised', text: 'We take care of every detail – from inspiration to your return home.' },
    { icon: '/pros/easy.png', title: 'Travel made easy', text: 'Whether multi-stop or multi-country, we make your travel wishes come true.' }
  ]
};

export const recommended = { h2: 'Other Egypt holidays you may like' };

export const planner = {
  h3: 'Customize your Egypt trip',
  social: 'One million happy travellers trust Hi Tours',
  nameLabel: 'Full name',
  namePlaceholder: 'e.g. Priya Sharma',
  phoneLabel: 'Phone number',
  phonePlaceholder: '98765 43210',
  emailLabel: 'Email address',
  emailPlaceholder: 'you@example.com',
  cta: 'Customize my escape',
  sending: 'Sending…',
  successTitle: 'Thank you!',
  successText: 'Your request is in. A Hi Tours expert will reach out shortly to build your trip.',
  known: 'Our accreditations:',
  bg: '/egypt/planner-bg.jpg',
  avatars: ['/egypt/tourlaner1.webp', '/egypt/tourlaner2.webp', '/egypt/tourlaner3.webp', '/egypt/tourlaner4.webp'],
};

export const crumbs = [
  { label: 'Destinations', href: '/#destinations' },
  { label: 'Africa', href: '/africa/egypt/holidays' },
  { label: 'Egypt', href: '/africa/egypt/' },
  { label: 'Egypt Explorer: Pyramids, Nile & Red Sea Beach Retreat — Grand Luxury Edition' }
];

export const trust = { label: 'Excellent', rating: 4.8, score: '4.8 out of 5', count: 'based on 420 Egypt reviews' };
export const reviewsHeading = 'What customers say about booking Egypt with Hi Tours';

export const price = { from: 'From', perPerson: 'per person', included: 'What\u2019s included', team: 'Ria Banerjee & our team' };

export const steps = {
  h2: 'Step by step to your trip',
  items: [
    { n: '1', title: 'Choose your destination', text: 'Want to make your dream trip a reality? Tell us a few details – your preferred destination, preferences and budget – and receive a free, personalised travel offer in under a minute.' },
    { n: '2', title: 'Personalise', text: 'In a 30-minute phone or video call we connect you with an expert who tailors your route even more precisely to you – with insider knowledge of every destination.' },
    { n: '3', title: 'Book', text: 'Confirm the offer and look forward to your trip! We take care of everything else with our all-round service – and are there for you on the go with our 24-hour emergency assistance.' }
  ]
};
